import { themeVar } from "@config/theme/cssVar";
import { brandPrimary, brandPrimaryHover, brandPrimarySurface, brandPrimarySurfaceHover } from "@config/theme/tokens";

export const MUI_TAB = {
	SELECTED: {
		TAB_NAME_COLOR: themeVar.primarySoftText,
		BACKGROUND_COLOR: themeVar.primarySoft,
		HOVER_COLOR: themeVar.primarySoftHover,
		INDICATOR_COLOR: brandPrimary,
	},
};

export const MUI_TOOLTIP = {
	TOOLTIP_BACKGROUND_COLOR: themeVar.foreground,
	TOOLTIP_COLOR: themeVar.primaryForeground,
	TOOLTIP_BOX_SHADOW: "0 4px 16px rgba(0, 0, 0, 0.28), 0 1px 4px rgba(0, 0, 0, 0.18)",
	TOOLTIP_BORDER_RADIUS: 6,
	TOOLTIP_FONT_SIZE: 12,
	TOOLTIP_PADDING: "10px 14px",
	TOOLTIP_LETTER_SPACING: 0.02,
	TOOLTIP_FONT_FAMILY: '"Poppins", sans-serif',
	TOOLTIP_LINE_HEIGHT: 1.45,
	TOOLTIP_MAX_WIDTH: 280,
};

export const MUI_MENU_ITEM = {
	SELECTED: {
		BACKGROUND_COLOR: brandPrimary,
		COLOR: themeVar.primaryForeground,
		HOVER_COLOR: brandPrimaryHover,
	},
	UNSELECTED: {
		BACKGROUND_COLOR: themeVar.surfaceMuted,
		COLOR: themeVar.foreground,
		HOVER_COLOR: brandPrimarySurfaceHover,
	},
};

export const MUI_STEPPER = {
	CONNECTOR: {
		LINE_BACKGROUND_COLOR: themeVar.borderStrong,
		ACTIVE_LINE_COLOR: themeVar.primary,
		COMPLETED_LINE_COLOR: themeVar.primary,
	},
};

/** Legacy exports for backward compatibility */
export const LEGACY_GREEN = brandPrimary;
export const LEGACY_GREEN_SURFACE = brandPrimarySurface;
